//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.CurveAlignedListBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.UnitCellBuilder.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AlignAtSplitCurve",1,0],[1,"BaseFace",0,"ScCollector",0],[1,"BoundaryBody",0,"ScCollector",0],[0,"Csys",1,"CoordinateSystem",0],[1,"CurveAlignedList",0,"GeometricUtilities.CurveAlignedListBuilder",0],[0,"DistanceTolerance",1,0],[0,"Layers",1,0],[1,"Offset",0,"Expression",0],[0,"OrientationPoint1",1,"Point",0],[0,"OrientationPoint2",1,"Point",0],[0,"Parameterization",1,0],[0,"ReverseFaceDirection",1,0],[1,"SplitCurve",0,"Section",0],[0,"Type",1,0],[1,"UnitCell",0,"GeometricUtilities.UnitCellBuilder",0]],[],[]];
SPLM.Features.BodyLattice2Builder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.BodyLattice2Builder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.BodyLattice2Builder.Types = Object.freeze({
    "UnitFill" : "UnitFill", "UnitSurfaceConformal" : "UnitSurfaceConformal"});

SPLM.Features.BodyLattice2Builder.ParameterizationType = Object.freeze({
    "Automatic" : "Automatic", "Planar" : "Planar", "Contour" : "Contour", "Cylindrical" : "Cylindrical", "CurveAligned" : "CurveAligned"});

export default SPLM;